import React from 'react';

import postalCodeNormalizerUS from '../validate/postalCodeNormalizerUS';
import { addressFieldNames as fields } from '../address/addressModule';
import { getFilteredStatesFromExcludedBillingStates } from '../utils/addressUtils';
import {
    defaultFieldProps,
    addressPropTypes,
    ADDRESS_CONTEXT
} from './addressFieldsModule';

import { fieldValidatorsUS } from './addressValidation';
import addressFields from './addressFieldMessages';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateSelectField,
    PostalCodeField
} from './Fields';
import stateMap, { usStateField } from './data/USStateMap';


export const makeStateList = (intl, excludedBillingStates, addressContext) => {
    let counties = Object.keys(stateMap);
    const placeholder = {
        value: '',
        label: intl.formatMessage(usStateField.stateLabel)
    };
    if (addressContext === ADDRESS_CONTEXT.BILLING) {
        counties = getFilteredStatesFromExcludedBillingStates(excludedBillingStates);
        switch (counties.length) {
            case 0:
                
                return [placeholder];
            case 1:
                return [{
                    value: counties[0],
                    label: intl.formatMessage(stateMap[counties[0]])
                }];
            default:
        }
    }
    return [placeholder].concat(counties.map(code => ({
        value: code,
        label: intl.formatMessage(stateMap[code])
    })));
};

export const AddressFieldsUS = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    useAddressAutocomplete,
    validators,
    excludedBillingStates,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.US.street1Label,
        updateShippingAddress,
        useAddressAutocomplete,
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.US.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.US.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        excludedBillingStates,
        label: addressFields.US.stateLabel,
        options: makeStateList(intl, excludedBillingStates, addressContext),
        validate: validators.get(fields.ADDRESS_STATE)
    };
    const postalCodeProps = {
        ...commonFieldProps,
        fieldType: 'tel',
        label: addressFields.US.postalCodeLabel,
        normalize: postalCodeNormalizerUS,
        validate: validators.get(fields.ADDRESS_POSTCODE)
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateSelectField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsUS.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsUS
};

AddressFieldsUS.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsUS;
